// If no effect ran after this amount of time, we assume that the render was not committed by React
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var CLEANUP_TIMER_LOOP_MILLIS = 1000;
export var TimerBasedCleanupTracking = /*#__PURE__*/ function() {
    "use strict";
    function TimerBasedCleanupTracking() {
        var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : CLEANUP_TIMER_LOOP_MILLIS;
        _class_call_check(this, TimerBasedCleanupTracking);
        this.timeouts = new Map();
        this.cleanupTimeout = CLEANUP_TIMER_LOOP_MILLIS;
        this.cleanupTimeout = timeout;
    }
    _create_class(TimerBasedCleanupTracking, [
        {
            key: "register",
            value: function register(object, unsubscribe, unregisterToken) {
                var _this = this;
                if (!this.timeouts) {
                    this.timeouts = new Map();
                }
                var timeout = setTimeout(function() {
                    if (typeof unsubscribe === 'function') {
                        unsubscribe();
                    }
                    _this.timeouts.delete(unregisterToken.cleanupToken);
                }, this.cleanupTimeout);
                this.timeouts.set(unregisterToken.cleanupToken, timeout);
            }
        },
        {
            key: "unregister",
            value: function unregister(unregisterToken) {
                var timeout = this.timeouts.get(unregisterToken.cleanupToken);
                if (timeout) {
                    this.timeouts.delete(unregisterToken.cleanupToken);
                    clearTimeout(timeout);
                }
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                if (this.timeouts) {
                    this.timeouts.forEach(function(value, key) {
                        _this.unregister({
                            cleanupToken: key
                        });
                    });
                    this.timeouts = undefined;
                }
            }
        }
    ]);
    return TimerBasedCleanupTracking;
}();
